export default "__VITE_ASSET__DaZZK_r0__"